<template>
  <div>
    <transition name="slide-fade">
      <div class="modal" v-show="commissionbillData.addable">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                详情
                <template v-if="baseData.shiyunBill">
                  [{{ baseData.shiyunBill.sn }}]
                </template>
              </h5>
              <button type="button" class="close" @click="closeClick">
                <i class="ki ki-close"></i>
              </button>
            </div>
            <div class="modal-body body_margin">
              <div class="body_card">
                <div class="body_title">基本信息</div>
                <div class="row">
                  <div class="col-4">
                    账单编号：<span v-if="baseData.shiyunBill">{{
                      baseData.shiyunBill.sn
                    }}</span>
                  </div>
                  <div class="col-4">
                    类型：<span v-if="baseData.shiyunBill">{{
                      eGetShiyunBillType(baseData.shiyunBill.type)
                    }}</span>
                  </div>
                  <div class="col-4">
                    状态：<span v-if="baseData.shiyunBill">{{
                      eGetShiyunBillStatus(baseData.shiyunBill.status)
                    }}</span>
                  </div>
                  <div class="col-4">
                    所属客户：<span v-if="baseData.shiyunBill">
                      {{ eGetShiyunBill(baseData.shiyunBill.userSN) }}</span
                    >
                  </div>
                  <div class="col-8">
                    账期：<span v-if="baseData.shiyunBill">{{
                      eGetDate(baseData.shiyunBill.cycleTime)
                    }}</span>
                  </div>
                  <div class="col-4">
                    创建人：<span v-if="baseData.creator">{{
                      baseData.creator.name
                    }}</span>
                  </div>
                  <div class="col-4">
                    创建时间：<span>{{ eGetTime(baseData.time) }}</span>
                  </div>
                  <div class="col-4">
                    更新时间：<span>{{ eGetTime(baseData.lastTime) }}</span>
                  </div>
                </div>
              </div>
              <div class="body_card">
                <div class="body_title">账单费用明细</div>
                <div class="row">
                  <div class="col-4">
                    原价金额：
                    <vi-amount
                      v-model="baseData.originalAmount"
                      :prefix="prefix"
                    />
                  </div>
                  <div class="col-4">
                    优惠金额：
                    <vi-amount
                      v-model="baseData.discountAmount"
                      :prefix="prefix"
                    />
                  </div>
                  <div class="col-4">
                    抹零金额：
                    <vi-amount
                      v-model="baseData.roundAmount"
                      :prefix="prefix"
                    />
                  </div>
                  <div class="col-4">
                    应付金额：
                    <vi-amount v-model="baseData.amount" :prefix="prefix" />
                  </div>
                  <div class="col-8">
                    税费金额：
                    <vi-amount v-model="baseData.taxAmount" :prefix="prefix" />
                  </div>
                  <div class="col-12">
                    账单概要：
                    <span>{{ baseData.name }}</span>
                  </div>
                  <div class="col-12">
                    账单明细：
                    <span v-if="baseData.shiyunBill">
                      {{ baseData.shiyunBill.detail }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="body_card">
                <div class="body_title">佣金结算</div>
                <div class="row">
                  <div class="col-4">
                    返佣类型：<span>{{
                      eGetCommissionType(baseData.commissionType)
                    }}</span>
                  </div>
                  <div class="col-4">
                    佣金金额：
                    <vi-amount
                      v-model="baseData.commissionAmount"
                      :prefix="prefix"
                    />
                  </div>
                  <div class="col-4">
                    状态：
                    <span>{{ eGetCommissionBillStatus(baseData.status) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-light-dark font-weight-bold close_ctrl"
                @click="cancelClick"
              >
                关闭
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- <transition name="fade">
      <div
        class="modal-backdrop"
        v-show="commissionbillData.backdropShow"
      ></div>
    </transition> -->
  </div>
</template>

<script>
var moment = require("moment");
export default {
  name: "PagesDashboardCommissionbillDetail",
  data() {
    return {
      baseData: {},
      prefix: "",
      sign: "",
      custmoerList: [],
    };
  },
  mounted() {},
  watch: {
    "commissionbillData.sn": {
      handler(newName) {
        this.prefix = this.$$.currency.prefix();
        this.sign = this.$$.currency.code();
        this.eGetOrderInfo(newName);
        this.eGetCustomerList();
      },
      immediate: true,
    },
  },
  methods: {
    closeClick() {
      this.$emit("input", false);
    },
    cancelClick() {
      this.$emit("e-cancel");
      this.$emit("input", false);
    },
    eGetCustomerList() {
      this.$$.api.data
        .list("/shiyun/aliyun/apis/data/customer", {
          columns: ["userSN", "name"],
        })
        .then((res) => {
          let data = res.data.list;
          data.map((p) => {
            this.custmoerList.push({ label: p.name, value: p.userSN });
          });
        });
    },
    eGetOrderInfo(sn) {
      this.$$.api.data
        .find("/shiyun/marketing/apis/data/commissionbill", {
          number: sn,
          columns: [
            "*",
            "user.*",
            "creator.*",
            "paymentOrder.*",
            "shiyunBill.*",
          ],
        })
        .then((res) => {
          this.baseData = res.data.item;
        });
    },
    eGetShiyunBill(val) {
      let find = this.custmoerList.find((p) => p.value == val);
      if (find) {
        return find.label;
      }
      return "";
    },
    eGetShiyunBillType(type) {
      let result = "";
      switch (type) {
        case "Prepay":
          result = "预付费";
          break;
        case "Postpay":
          result = "后付费";
          break;
        case "Refund":
          result = "退款";
          break;
        case "Adjustment":
          result = "调账";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetShiyunBillStatus(status) {
      let result = "";
      switch (status) {
        case "New":
          result = "新订单";
          break;
        case "Paid":
          result = "已支付";
          break;
        case "Canceled":
          result = "已取消";
          break;
        case "Remove":
          result = "废弃";
          break;
        case "WaitPay":
          result = "待支付";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetCommissionBillStatus(status) {
      let result = "";
      switch (status) {
        case "New":
          result = "未支付";
          break;
        case "Paid":
          result = "已支付";
          break;
        case "Canceled":
          result = "取消";
          break;
        case "Remove":
          result = "作废";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetCommissionType(val) {
      let result = "";
      switch (val) {
        case "ProductAmount":
          result = "产品原价";
          break;
        case "PaymentAmount":
          result = "产品支付金额";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetTime(time) {
      let result = "";
      let m = moment(time).format("YYYY-MM-DD");
      if (m === "0009-01-01") {
        return result;
      } else if (m === "9999-01-01") {
        return result;
      }
      result = moment(time).format("YYYY-MM-DD HH:mm:ss");
      return result;
    },
    eGetDate(time) {
      let result = "";
      let m = moment(time).format("YYYY-MM-DD");
      if (m === "0009-01-01") {
        return result;
      } else if (m === "9999-01-01") {
        return result;
      }
      result = moment(time).format("YYYY-MM-DD");
      return result;
    },
  },
  props: {
    commissionbillData: Object,
  },
};
</script>

<style lang="scss" scoped>
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0 !important;
}
.modal-backdrop {
  transition: opacity 0.3s linear;
  opacity: 0.2;
}
.modal {
  display: block;
}
.modal-footer {
  justify-content: center;
  border-top: none;
  .close_ctrl {
    width: 150px;
    color: #fff;
  }
}
.body_margin {
  .body_card {
    div {
      margin: 5px 0px;
    }
  }
}
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-50px);
  opacity: 0;
}
.body_title {
  font-size: 16px;
  color: #101010;
}
</style>
